import React from 'react';
import { StaticSplashContent } from '.';

export const sa: StaticSplashContent = {
  awards: [],
  brandColor: '#f0ac18',
  brandHoverColor: '#d49715',
  classics: {
    description: 'some description goes here',
    title: 'SEXART CLASSICS',
  },
  galleries: {
    description:
      'Thousands of arousing images featuring beautiful models expressing their authentic pleasure, shot by internationally renowned photographers.',
    path: '/galleries',
    title: 'SUPERB EROTIC PHOTOGRAPHY',
  },
  infoPanels: {
    one: {
      buttonText: 'BECOME A MEMBER NOW',
      campaign: 'static-splash-info-panel-1',
      description: (
        <>
          Get Unlimited, Uncensored Access to <br />
          Our Award-Winning Site
        </>
      ),
      highlightText:
        'Established in 2012 Sexart is the gold standard for explicit, artistic sex films. Enjoy an unrivalled collection of big budget erotic productions.',
    },
    two: {
      buttonText: '',
      campaign: 'static-splash-info-panel-2',
      description: (
        <>
          Get Unlimited, Uncensored Access to <br />
          Our Award-Winning Site
        </>
      ),
      highlightText:
        'Erotic art is distinguished by its ability to blend raw intimacy with creativity and excellent production values to engage your senses on multiple levels.',
    },
  },
  intro: {
    buttonText: 'JOIN NOW',
    buttonTextNonNude: 'UNLOCK EXPLICIT FILMS NOW',
    largeTagline: 'Sexart is the global leader in Explicit Erotic Films and Sensual Photography',
    smallTagline: 'See natural beauties share their pleasure in daily updates',
  },
  models: {
    description:
      'Over 2000 stunning explicit artistic sex films featuring gorgeous girls having fun with their boyfriends and girlfriends.',
    path: '/models',
    title: 'THE WORLD’S HOTTEST COLLECTION OF EROTIC FILMS',
  },
  movies: {
    description: 'Over 2000 provocative movies, an unrivalled, award-winning collection of big-budget productions.',
    path: '/movies',
    title: 'EXCEPTIONAL FILMMAKING',
  },
  outro: {
    buttonText: 'JOIN SEXART TODAY',
    largeTagline: 'Step into a world where authentic chemistry is captured in intimate detail',
    smallTagline: 'See natural beauties share their pleasure in daily updates',
    smallTaglineNonNude: 'Unlock the world’s most exclusive collection of explicit erotic films.',
  },
  seoText: '',
};
